/**
 * 文件简介：
 * - 睡眠大屏父级 ECharts 实例池（第三阶段：按固定槽位 slot-0..7 复用，轮播只 setOption）
 * - 实例挂在 sleep.vue，子视图通过 inject('chartPool') 读写
 * 使用方法：merge 到 sleep.vue 的 data / methods，并在 sleep.vue 中 provide('chartPool')
 * 原理：
 * - chartPool.instances 键为 slot-N，与 DOM id wave-chart-{view}-slot-N 一一对应
 * - slotBinding 记录槽位当前绑定的患者业务键，切页换患者时触发全量 setOption
 * - 仅 sleep 根组件卸载时 disposeChartPool 全量释放
 */

import chartLifecycleStats from '@/utils/chartLifecycleStats';

export default function useChartPool() {
  return {
    data() {
      return {
        /**
         * 全局图表池（第三阶段元素池）
         * instances: { [slotKey]: EChartsInstance }  如 slot-0 .. slot-7
         * optionCache: { [slotKey]: option }
         * slotBinding: { [slotKey]: patientBindingKey }  槽位当前展示的患者
         */
        chartPool: {
          instances: {},
          optionCache: {},
          slotBinding: {},
        },
      };
    },

    methods: {
      /**
       * 大屏根组件销毁时释放池中全部图表实例
       */
      disposeChartPool() {
        const pool = this.chartPool;
        if (!pool || !pool.instances) return;

        Object.keys(pool.instances).forEach((slotKey) => {
          const chart = pool.instances[slotKey];
          if (!chart) return;
          chartLifecycleStats.recordDispose('dispose-all', slotKey);
          try {
            if (chart.clear) chart.clear();
            if (chart.dispose) chart.dispose();
          } catch (e) {
            // 忽略已销毁实例
          }
        });

        pool.instances = {};
        pool.optionCache = {};
        pool.slotBinding = {};
      },
    },
  };
}
